/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Compare_Event_Groups_Close_LabelInputs */

const en_compare_event_groups_close_label = /** @type {(inputs: Compare_Event_Groups_Close_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Close`)
};

const fr_compare_event_groups_close_label = /** @type {(inputs: Compare_Event_Groups_Close_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fermer`)
};

const de_compare_event_groups_close_label = /** @type {(inputs: Compare_Event_Groups_Close_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schließen`)
};

const it_compare_event_groups_close_label = /** @type {(inputs: Compare_Event_Groups_Close_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vicino`)
};

const ru_compare_event_groups_close_label = /** @type {(inputs: Compare_Event_Groups_Close_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Закрывать`)
};

const es_compare_event_groups_close_label = /** @type {(inputs: Compare_Event_Groups_Close_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cerca`)
};

const zh_cn2_compare_event_groups_close_label = /** @type {(inputs: Compare_Event_Groups_Close_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`关闭`)
};

const ja_compare_event_groups_close_label = /** @type {(inputs: Compare_Event_Groups_Close_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`近い`)
};

const hi_compare_event_groups_close_label = /** @type {(inputs: Compare_Event_Groups_Close_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`बंद करना`)
};

const pt_pt2_compare_event_groups_close_label = /** @type {(inputs: Compare_Event_Groups_Close_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fechar`)
};

/**
* | output |
* | --- |
* | "Close" |
*
* @param {Compare_Event_Groups_Close_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const compare_event_groups_close_label = /** @type {((inputs?: Compare_Event_Groups_Close_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Compare_Event_Groups_Close_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_compare_event_groups_close_label(inputs)
	if (locale === "de") return de_compare_event_groups_close_label(inputs)
	if (locale === "it") return it_compare_event_groups_close_label(inputs)
	if (locale === "ru") return ru_compare_event_groups_close_label(inputs)
	if (locale === "es") return es_compare_event_groups_close_label(inputs)
	if (locale === "zh-CN") return zh_cn2_compare_event_groups_close_label(inputs)
	if (locale === "ja") return ja_compare_event_groups_close_label(inputs)
	if (locale === "hi") return hi_compare_event_groups_close_label(inputs)
	if (locale === "pt-PT") return pt_pt2_compare_event_groups_close_label(inputs)
	return en_compare_event_groups_close_label(inputs)
});